import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from 'axios';
import moment from 'moment-timezone';
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';

function Dashboard({state}) {
	const {weatherData, protoStats, priceData, solarData, solarHistory, sensorData, gridData, wolfet} = state.data;

	const mean = (x, y) => (x+y)/2;

	const fixedNum = (x) => x ? x.toFixed(1) : 'Err';

	return (
		<div className='dashboard'>
			<div className='dashboard-stats'>
				{weatherData ?
					<>
						<p className='small'>{weatherData.weather[0].description}</p>
						<p>{fixedNum(weatherData.main.temp)}°, {fixedNum(weatherData.main.feels_like)}°, {weatherData.main.humidity}%</p>
					</>
				:
					<p>Loading weather</p>
				}

				{protoStats ?
					<p>
						{protoStats.member_count}, {protoStats.card_scans}, {protoStats.minecraft_players.length}
					</p>
				:
					<p>Loading Protopace</p>
				}

				{priceData ?
					<>
						<p>{(priceData.data.btc_cad / 1000).toFixed(1)}k, {fixedNum(priceData?.data?.volume)}</p>
					</>
				:
					<p>Loading prices</p>
				}

				{solarHistory && solarData && solarData.timestamp ?
					<>
						<p>
							{solarData.actual_total}W, {parseInt(solarData.actual_total / 5985 * 100)}%{' '}
							<div className='sparkline'>
								<Sparklines data={solarHistory.map(x => x.actual_total)} height={50}>
									<SparklinesLine color='white' />
								</Sparklines>
							</div>
						</p>
						<p>{solarData.today_energy}kWh, {solarData.timestamp.substring(11, 16)}</p>
					</>
				:
					<p>Loading solar</p>
				}

				{sensorData ?
					<>
						<p>O: {fixedNum(sensorData.temperature.Outside[0].temperature_C)}° B: {fixedNum(sensorData.temperature.Bedroom[0].temperature_C)}°</p>
						<p>N: {fixedNum(sensorData.temperature.Nook[0].temperature_C)}° T: {fixedNum(sensorData.temperature.Basement[0].temperature_C)}°</p>
						<p>P10: {fixedNum(sensorData.air['Living Room'][0].pm10)} P25: {fixedNum(sensorData.air['Living Room'][0].pm25)}</p>
						<p>C: {fixedNum(sensorData.air['Living Room'][0].co2)} V: {sensorData.air['Living Room'][0].voc_idx}</p>
					</>
				:
					<p>Loading sensors</p>
				}

				{wolfet && wolfet.mapname &&
					<>
						<p>ET: {wolfet.mapname}, {wolfet.num_players}</p>
						<p className='playerlist'>{wolfet.players.join(', ')}</p>

					</>
				}
			</div>

		</div>
	);
}

export default Dashboard;
